module.exports = __webpack_public_path__ + "static/img/mobile.7a26f748.png";